<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>Mapvgl</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/mapvgl/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "1.0.0-beta.195",
          linkList: [ur + "1.0.0-beta.195/mapvgl.min.js"]
        },
        {
          label: "1.0.0-beta.194",
          linkList: [ur + "1.0.0-beta.194/mapvgl.min.js"]
        },
        {
          label: "1.0.0-beta.189",
          linkList: [ur + "1.0.0-beta.189/mapvgl.min.js"]
        },
        {
          label: "1.0.0",
          linkList: [ur + "1.0.0/mapvgl.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListMapvgl.vue